import ProductLike from './ProductLike'

export default ProductLike
